import axios from '../axios';
const END_POINT = '/permissions';

const getPermissions = () => axios.get(`${END_POINT}`);
const addPermission = (permission) => axios.post(`${END_POINT}`, permission);
const deletePermission = (permission) => axios.delete(`${END_POINT}/${permission}`);
const editPermission = (permission, id) => axios.patch(`${END_POINT}/${id}`, permission);
const getAPermission = (id) => axios.get(`${END_POINT}/${id}`);

export {
    getPermissions, addPermission, deletePermission, editPermission, getAPermission
}